import _ from "lodash";

export function paginate(items, pageNumber, pageSize) {
  const startIndex = (pageNumber - 1) * pageSize;
  return _(items)
    .slice(startIndex)
    .take(pageSize)
    .value();
}

export function getPagedData(pageSize, currentPage, allItems){
  const items = paginate(allItems, currentPage, pageSize);
  return { totalCount: allItems.length, data: items };
};